module.exports =  {
  TITLE: {
    default: '搜索酒店|亚洲数万家酒店在线预订',
    detail: '|百高酒店預訂',
  },
  hotel: {
    // 酒店搜索改版新增翻译--繁体
    ROOMS: '客房數',
    GUESTS: '住客數',
    CHECK_IN_NUM: '入住人數',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: '成人',
    SUFFIX_ADULTS: '成人',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: '兒童',
    SUFFIX_CHILDREN: '兒童',
    CHILD_AGE: '兒童年齡',
    NO_MATCH_TIPS: '以下客房不符合“間數”、“人數”篩選條件',

    Book_Hotel: '酒店預訂',
    Select_your_destination: '請選擇目的地',
    Please_enter_your_destination: '請輸入目的地/酒店',
    Booked_up: '已訂完',
    Hotel_description: '酒店介紹',
    Check_in_date: '入住日期',
    Check_out_date: '退房日期',
    Sold_out: '售完',
    Non_refundable: '不可取消',
    reserve: '訂',
    Pay_Online: '在線付',
    Only_rooms_left_before: '仅剩',
    Only_rooms_left_after: '間',
    Cancellation_Policy: '取消政策',
    See_all_prices_before: '查看全部',
    See_all_prices_after: '個價格',
    Estimated_time_of_arrival: '預計到店',
    make_your_schedule_well_planned: '為當地時間，選定後請合理安排出行。',
    Hotel_Not_Found: '未找到所選條件的酒店',
    Please_change_your_search: '請修改條件重新查詢',
    Submit_an_application: '提交申請',
    Hotel_Confirmation: '酒店確認',
    Many_Night_Stay_before: '入住',
    Many_Night_Stay_after: '晚',
    Hotel_Booking_Number: '酒店預約號',
    Online_Payment: '在線支付',
    The_guest_Room_before: '入住人【房間',
    The_guest_Room_after: '】',
    Contact_number: '聯繫號碼',
    Bring_all_valid_IDs: '入住時請攜帶所有入住人的有效身份證件。',
    Hotels_Found_before: '搜索到',
    Hotels_Found_after: '家酒店',
    Hotels_Presented_before: '當前顯示',
    Hotels_Presented_center: '家酒店(共',
    Hotels_Presented_after: '家)',
    Please_change_the_dates: '沒有查詢到所選日期的房型，請重新選擇住宿日期。',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '共',
    Nights_in_total_after: '晚',
    Location: '酒店位置',
    Pictures: '酒店圖片',
    Description: '酒店介紹',
    Policy: '酒店政策',
    Check_in_and_check_out_time: '入離時間',
    Check_in_and_Check_out_before: '入住時間：',
    Check_in_and_Check_out_center: '以后  離店時間：',
    Check_in_and_Check_out_after: '以前',
    Check_in_time: '入住時間',
    Check_out_time: '離店時間',
    Hotel_Information: '基本信息',
    Opening_Date: '開業時間',
    Renovation_Date: '裝修時間',
    Facility_Service: '設施服務',
    Payment_methods: '酒店接受的支付方式',
    Hotel_Address: '酒店地址',
    Pay_online: '在線支付',
    Pay_offline: '線下支付',
    Night_stay_before: '入住',
    Night_stay_after: '晚,',
    Rooms_total_before: '間共',
    Rooms_total_after: '',
    Guest_name_must_be_provided: '入住人姓名必須填寫完整',
    Please_fill_in_your_contact_number: '請輸入聯繫號碼',
    Select_estimated_time_of_arrival: '請選擇預計到店時間',
    Number_of_Rooms: '房間數量',
    Maximum_guests_per_room_before: '每間最多入住',
    Maximum_guests_per_room_after: '人',
    Many_Rooms: '間',
    Service_Fee_Included: '(含稅和服務費)',
    Last_Name: '姓氏拼音',
    First_Name: '名字拼音',
    Room: '房間',
    Additional_Tax: '另付稅費',
    Please_inform_the_hotel: '若超過登記的預計到店時間，請務必聯絡住宿酒店。',
    Please_inform_the_hotel_first: '沒有提前與酒店聯絡，導致超過最遲入住時間時，房間或晚餐安排會有影響，請注意提前確認。',
    Booking_Cancellation: '取消訂單',
    Reason_of_Cancellation: '取消原因',
    Incorrect_Information_Filled: '信息填錯',
    Itinerary_Changed: '行程改變',
    Lower_price_on_other_APP: '其他APP更便宜',
    Low_quality_hotel: '酒店质量差',
    Book_at_a_lower_price: '前台預訂更實惠',
    Other: '其他',
    Please_write_your_reason: '請填寫原因',
    After_cancellation_done: '取消成功後，款項將會在3個工作日退回到您的原支付方。',
    How_to_fill_in_the_guest_name: '入住人填寫說明',
    It_should_be_exactly_the_same: '預訂酒店必須填寫入住人的姓名，以英文字母填寫。需與入住時所持證件完全一致。',
    How_to_fill_in_a_Chinese_name: '中文姓名填寫方法：',
    How_to_fill_in_a_English_name: '英文姓名填寫方法：',
    For_example: '例如：“韓梅梅”，姓填寫“Han”，名填寫“Meimei”',
    No_specical_characters: '英文姓名中不能包含數字或特殊符號',
    Name_rule_first: '② 姓在前，名在後，如有中間名則空一格緊隨名之後。',
    Name_rule_second: ' 例如：Green / Jim Stephanie',
    Details: '明細',
    Pay_now: '立即支付',
    Hotel: '酒店',
    Check_in: '入住：',
    Car: '租車',
    All_bookings: '全部訂單',
    All: '全部',
    PROMPT: '提示',

    Search: '搜索',
    COST_DESCRIPTION: '費用明細',
    TOTAL: '合計',
    SEE_ORDER_INFO_TO: '支付',
    KONW: '知道了',
    BOOKING_INFORMATION: '預訂須知',
    Book_Now: '立即支付',
    MAP: '地圖',
    CONTACT_INFORMATION: '聯繫方式',
    LOADING: '加載中...',
    SORT_FILTER: '排序/篩選',
    SCREENING: '篩選',
    SEQUENCE: '排序',
    PHONE_ASK: '電話諮詢',
    ABOVE: '起',
    SUBMINT_ORDER: '提交訂單',
    OK: '確定',
    Order_detail: '訂單明細',
    BOOKING_INFO: '訂單信息',
    PAYMENT_AMOUNT: '訂單金額',
    Order_time: '下單時間',
    ORDER_NUMBERS: '訂單號',
    PAY_TYPE: '支付方式',
    BALANCE: '賬戶餘額',
    CURRENT_BALANCE_BEGIN: '當前餘額',
    OVERPLUS_BALANCE_BEGIN: '結餘',
    OTHER_PAYMENT: '其他支付方式',
    Unionpay: 'UnionPay',
    Wechatpay: '微信支付',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: '點擊“立即支付”即表示您同意百高',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《服務協議》',
    PAYMENT_ORDER: '支付訂單',
    Total_pay: '应付总額',
    PAY_SUCCESS: '支付成功',
    CHECK_THE_ORDER: '查看訂單',
    BACK_TO_INDEX: '返回首頁',
    CANCEL: '取消',
    RECOMMED: '百高推薦',
    PRICE: '價格',
    HIGH: '高',
    LOW: '低',
    RESET: '重置',
    SELECT_TIME: '選擇日期',
    Hotel_guest: '入住人',
    Select: '請選擇',
    Emial_address: '請輸入郵箱地址',
    Booking_explan: '預訂說明',
    VIEW_MORE: '查看更多',
    COLLAPSE: '收起',
    Week: '週',
    Month: '月',
    TOURISM_CHECK_IN_HOTEL: '入住',
    TOURISM_LEAVE_HOTEL: '離店',
    arrive: '目的地',
    Room_description: '客房說明',
    Meals: '餐饮',
    Room_Type: '房型',
    BOOKING_EXPLANATION: '預訂說明',
    BOOKING_BUTTON: '預訂',
    REMIND_SUBMIT_ORDER: '繼續預訂',
    login_now: '預訂酒店需要登錄，立即登錄？',
    the_real_scene: '圖片僅供參考，請以實際入住酒店為準',
    Bed: '床型',
    Rooms: '房型信息',
    Room_rate: '房費情況',
    notified_by_SMS: '訂成功後，會向您發送短信通知',
    email_notifications: '用於接收郵件通知',
    Booking_deadline: '截止預訂時間',
    Child: '兒童',
    Additional_notes_about_payment: '額外費用',
    Nights: '入住天數',
    Minimum_nights_before: '至少',
    Minimum_nights_after: '天',
    Size: '面積',
    Guests: '人數',
    Room_rate_1: '房費',
    Tax_service_fee: '稅和服務費',
    Pay_now_1: '去支付',
    Filter: '篩選條件',
    Room_rate2: '費用',
    Show_on_map: '查看地圖',
    Detail: '查看詳情',
    Room_Detail: '查看房间詳情',

    TAXES_INCL: '含稅總價',
    SEARCH_EMPTY_TIP: '抱歉，此酒店在所選日期內我們沒有空房了，您可以： ' +
      '搜索其他日期 或者 搜索其他酒店住宿',
    severalNight: '晚',
    immediateBooking: '立刻預訂',
    Refundable: '條件取消',
    MORE: '更多',
    adultsCompany: '名大人',
    ServiceTerms: '入住條款',
    roomPlan: '方案',
    guestRoom: '客房',
    searchAgain: '重新搜索',
    roomNight: '間/夜',

    NAME_TXT: '姓名',
    HOLDER_NAME: '持卡人姓名',
    EXPIRATION_DATE: '到期日',
    FORMAT_TXT: '格式',
    SECURITY_CODE: '安全碼',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '卡片背後的3比特數位。',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '卡片正面的4位數',
    ENTER_COMPLETE_CARD_NUM: '請輸入完整卡號',
    PLEASE_ENTER_HOLDER_NAME: '請輸入持卡人姓名',
    ENTER_SECURITY_CODE: '請輸入安全碼',
    ENTER_EXPIRATION_DATE: '請輸入到期日',
    ROOM_DETAILS: '客房詳情',
    CONDITION_CANCEL: '條件取消',
    CHOOSE_PAYMENT_METHOD: '選擇支付方式',
    ORDER_TOTAL_LUMP: '訂單總額',
    CREDIT_CARD_NUM: '借記卡/信用卡號',
    MAINLAND_CARD_ONLY: '僅限中國大陸以外地區發行的銀行卡',
    SHUT_DOWN: '關閉',
    PROVIDER_FROM_CHINA_BANK: '由中國銀行提供支付服務',

    COUPON: '優惠券',
    APPLY_A_COUPON: '優惠券兌換',
    NO_USE: '所结算商品不可使用',
    Discard: '放棄',
    REDEEM: '兌換',
    EMPTY_COUPON: '請輸入優惠碼',
    NOTICE_COUPON: '每次只可以使用壹張優惠券；提交訂單後，該優惠券將被認為已經使用。',

    BREAKFAST_INCLUDE: '含餐',
    BREAKFAST_EXCLUDE: '不含餐',
    DOUBLE_BED: '大床',
    TWIN_BED: '双床',
    FREE_CANCEL: '免費取消',
    MEALS: '餐食',
    EVALUATION: '評價',
    FEATURED_REVIEWS: '評價精選',
    ALL_REVIEWS: '全部評價',
    OVERALL_EVALUATION: '總體評價',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '差',
    EVAL_GENERAL_LIST_2: '不好',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '好',
    EVAL_GENERAL_LIST_5: '很好',
    MAX_IMAGES_WITH_NINE: '最多只能選擇9張圖片',
    GRADE_EVAL: '請選擇總體評價',
    DISTANCE_FILTER: '距離 近→遠',
    EDIT_EVALUATION: '寫評價',
    GO_TO_EVAL: '去評價',
    EVAL_POINTS_AWARD: '最高可獲1000積分(可抵扣10RMB)',
    NEARBY_LIKE_HOTEL: '附近相似酒店',
    DISTANCE_HOTEL: '距離酒店',
    PLEASE_ENTER_COMMENT: '請輸入評價內容',
    AWARD_POINTS_TIPS: '評論有機會贏1000積分 (可抵扣10RMB)',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名評價不會展示您的頭像和暱稱',
    LOCATION: '位置',
    FACILITY: '設施',
    SERVICE: '服務',
    HEALTH: '衛生',
    LANGUAGE_SELECT: '語言選擇',
    LIMIT_COMMENT_TXT: '評價字數必須在 5~2000 內',
    SHARE_MEDIA: '分享視頻/圖片',
    SETTLEMENT_FEEL: '入住感受',
    SUBMIT_EVAL: '提交',
    HOTEL_STR: '詳情',
    EVAL_NUM_AFTER: '條評價',
  },
  header: {
    SKIING: '雪場',
    header_internal_call: '中國大陸：',
    header_abroad_call: '海外：',
    header_app_download: '手機版',
    service_telephone: '客服電話',
    account_number: '賬號',
    if_bg_user: '還不是百高會員？',
    home: '首頁',
    hotel: '酒店',
    Golf: '高爾夫',
    PLAY_STAY: '球+酒',
    RENT_CAR_HOME: '租車',
    center_user: '會員中心',
    header_my_order: '我的訂單',
    header_notmember_order: '非會員訂單',
    header_edit_password: '修改密碼',
    header_logout: '登出',
    header_login: '登錄',
    header_register: '註冊',
    header_point: '我的積分',
    header_all_language: '所有語言',
    down_load_app: '掃描QR碼下載',
    login_discount_tip: '登錄獲得積分和其它獨家優惠',
    currency_balance_limit: '當前貨幣仍有餘額，無法切換貨幣'
  },
  footer: {
    footer_partner: '合作夥伴',
    footer_about_us: '關於我們',
    footer_about_baigolf: '關於BaiGolf.com',
    footer_privacy_policy: 'BaiGolf.com隱私政策',
    footer_use_of_terms: 'BaiGolf.com服務條款',
    footer_contact_us: '聯系我們',
    footer_sitemap: '網站地圖',
    footer_use_of_question: '常見問題',
    footer_ios_system: 'iOS系統',
    footer_android_system: '安卓系統',
    footer_app_load: 'APP下载',
    footer_sina_weibo: '新浪微博',
    footer_tencent_weibo: '騰訊微博',
    footer_share_to: '分享至',
    copyright1: '广州市百高美燚信息技术有限公司 版权所有',
    copyright2: '粤ICP备14070002号',
    news_center: '新聞中心',
    about_baigolf: '關於BaiGolf',
    help: '幫助',
    management_system: '球會管理系統',
    wechat_official_account: '關注微信公眾號',
    download_baiGolf_app: '掃碼免費下載App',
    privacy_policy: '隱私政策',
    use_of_terms: '服務條款',
    footer_integral: '積分政策',
    footer_reserve: '預訂政策',
    footer_abroad_call: '海外',
    footer_internal_call: '中國大陸'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh_hk.js